function setupReviewModal(event) {
  event.preventDefault();

  $("#confirm-submit-review-modal").appendTo("body").modal();
  $("#confirm-submit-review-modal .confirm").attr("href", $(this).attr("href"));
}

$(document).on("click", ".submit-for-review", setupReviewModal);
